import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Record } from '3map-models';
import { FetchStatus } from '../../shared/models/fetch-status.model';
import { SidenavActions } from '../../sidenav/+state';
// import { ProjectActions } from '../../project/+state';
import * as ProjectActions from '../../project/+state/project.actions';
import * as RecordActions from './record.actions';
import { EditorActions } from '../../record-editor/+state';

export const recordsFeatureKey = 'records';

export interface State extends EntityState<Record> {
  recordsFetchState: FetchStatus;
  totalRemoteCount: number;
}

export const adapter: EntityAdapter<Record> = createEntityAdapter<Record>({
  selectId: (record: Record) => record.recordId,
});

export const initialState: State = adapter.getInitialState({
  recordsFetchState: 'INITIAL',
  totalRemoteCount: -1,
});

export const reducer = createReducer(
  initialState,
  on(ProjectActions.closeProject, () => ({
    ...initialState,
  })),
  on(
    ProjectActions.fetchProject,
    ProjectActions.fetchProjectError,
    (): State => initialState,
  ),
  on(
    RecordActions.fetchRecords,
    SidenavActions.reloadRecords,
    (state): State => ({
      ...state,
      recordsFetchState: 'PENDING',
    }),
  ),
  on(
    RecordActions.fetchRecordsSuccess,
    (state, { resRecordList }): State =>
      adapter.setAll(resRecordList.recordList, {
        ...state,
        totalRemoteCount: resRecordList.totalRemoteCount,
        recordsFetchState: 'SUCCESS',
      }),
  ),
  on(
    RecordActions.fetchRecordsError,
    (state): State => ({ ...state, recordsFetchState: 'ERROR' }),
  ),
  on(EditorActions.uploadRecordSuccess, (state, { record }): State => {
    const recordExists = state.entities[record.recordId];
    const totalRemoteCount = recordExists
      ? state.totalRemoteCount
      : state.totalRemoteCount + 1;
    return { ...adapter.upsertOne(record, state), totalRemoteCount };
  }),
  on(
    EditorActions.deleteRecordsSuccess,
    (state, { recordIdsList }): State =>
      adapter.removeMany(recordIdsList, {
        ...state,
        totalRemoteCount: state.totalRemoteCount - recordIdsList.length,
      }),
  ),
  on(RecordActions.clearRecords, (state): State => adapter.removeAll(state)),
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();
